import TextField from '@mui/material/TextField';
import { styled } from '@mui/material/styles';

/** Single-row 40px field whose start adornment holds removable tokens; the input stretches to fill the rest. */
export const TokenTextField = styled(TextField, {
  shouldForwardProp: prop => prop !== 'hasTokens',
})<{ hasTokens?: boolean }>(({ theme, hasTokens }) => ({
  '& .MuiInputBase-root': {
    alignItems: 'center',
    height: 40,
    paddingRight: theme.spacing(1),
  },
  '& .MuiInputBase-input': {
    flex: 1,
    minWidth: 0,
    width: 'auto',
    ...(hasTokens && { padding: 0 }),
  },
}));
